const Footer = () => {
  return (
    <footer
      className="mt-auto py-4"
      style={{
        backgroundColor: "#080A0F",
        borderTop: "1px solid rgba(255,255,255,0.06)",
      }}
    >
      <div className="container mx-auto text-center">
        <p className="text-sm" style={{ color: "#64748B" }}>
          Copyright © 2025 Cardiowell. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
